import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    loading: false,
    response: undefined,
    error: undefined,
};

export const AddQuizSlice = createSlice({
    name: "addQuiz",
    initialState,
    reducers: {
        addQuizRequest(state) {
            state.loading = true;
        },
        addQuizRequestSuccess(state, action) {
            state.loading = false;
            state.response = action.payload;
            state.error = undefined;
        },
        addQuizRequestError(state, action) {
            state.loading = false;
            state.error = action.payload;
            state.response = undefined;
        },
    },
});

export const {
    addQuizRequest,
    addQuizRequestSuccess,
    addQuizRequestError,
} = AddQuizSlice.actions;

export default AddQuizSlice.reducer;